<template>
  <div class="submitBtn">
    <button type="submit" :name="name"
            :class="{'c-button-blue -login': true, '-disabled': !enabled}" @click="emit('click')">
      <span class="label"><slot></slot></span>
    </button>
  </div>
</template>

<script setup lang="ts">
  withDefaults(defineProps<{
      enabled?: boolean;
      name?: string;
    }>(), 
    {
      enabled: false,
      name: '',
    }
  )
  const emit = defineEmits<{
    (e: 'click'): void
  }>()
</script>
